// extracted by mini-css-extract-plugin
export default {"Toolbar":"Toolbar_Toolbar__nZBKS","Logo":"Toolbar_Logo__n+OTl","DesktopOnly":"Toolbar_DesktopOnly__9+c+R"};